/* Return to a bundle after using the product's native customization app. */
(()=>{
  let saved;
  try{saved=JSON.parse(sessionStorage.getItem('aa-offer-return')||'null');}catch{return;}
  if(!saved||Date.now()-saved.createdAt>2*60*60*1000||!location.pathname.includes('/products/'))return;
  let target;try{target=new URL(saved.url,location.origin);}catch{return;}
  if(target.origin!==location.origin||!target.pathname.startsWith('/collections/'))return;
  const main=document.querySelector('main');if(!main)return;
  const banner=document.createElement('aside');banner.className='aa-offer-return';banner.setAttribute('aria-label','Continue your four-piece offer');
  const link=document.createElement('a');link.className='button button--outline';link.href=target.pathname+target.search+target.hash;link.textContent='Back to your four-piece offer';banner.append(link);main.prepend(banner);
  document.addEventListener('cart:change',event=>{
    if(event.detail?.baseEvent==='variant:add')link.textContent='Piece added · Continue choosing your four';
  });
})();
